import { Component, Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class DateService {

    constructor(private translate: TranslateService) { }

    getWeekdayShortName(weekday: number): string {
        return this.translate.instant('weekdays.' + [weekday - 1]);
    }

    getMonthShortName(month: number): string {
        return this.translate.instant('months.' + [month - 1]);
    }

    getMonthFullName(month: number): string {
        return this.getMonthShortName(month);
    }

    fromModel(date: string): NgbDateStruct {
        if (date) {
            const model = new Date(date);
            return model ? { year: model.getFullYear(), month: model.getMonth() + 1, day: model.getDate() } : null;
        } else {
            return null;
        }
    }

    toModel(date: NgbDateStruct): String {
        return `${date.year}-${date.month}-${date.day}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/date.service.ts